<div class="reports-inner">
  <ul class="activity-ul">
    <li *ngFor="let activity of showActivities; let i = index">
      <label>{{ activity.activityString }}</label>
      {{ activity.timeString }}
    </li>
    <li *ngIf="noActivityLog">No activity found.</li>
  </ul>
</div>
